import { render } from "./DialogoSistema.vue?vue&type=template&id=6ec8f8f5&scoped=true&ts=true"
import script from "./DialogoSistema.vue?vue&type=script&lang=ts"
export * from "./DialogoSistema.vue?vue&type=script&lang=ts"

import "./DialogoSistema.vue?vue&type=style&index=0&id=6ec8f8f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec8f8f5"]])

export default __exports__